/**
 * Paid CareMap carousel ordering: higher max CPC first; merge mode unchanged elsewhere.
 * @param {object[]} slides paid carousel slide objects with numeric `sortCpc`
 * @returns {object[]}
 */
export function sortPaidCarouselAdsByCpcDesc(slides) {
  if (!Array.isArray(slides)) {
    return [];
  }
  return [...slides].sort((a, b) => {
    const da = Number(a?.sortCpc) || 0;
    const db = Number(b?.sortCpc) || 0;
    return db - da;
  });
}
